<div class="backdrop">
    <div class="modal">
        <div class="input-container">
            <div class="input ratio">
                <label for="aspectRatio">Relación:</label>
                <select id="aspectRatio" [(ngModel)]="aspectRatio">
                    <option [ngValue]="1 / 1">1:1 (Cuadrado)</option>
                    <option [ngValue]="4 / 3">4:3</option>
                    <option [ngValue]="16 / 9">16:9</option>
                    <option [ngValue]="3 / 4">3:4</option>
                    <option [ngValue]="9 / 16">9:16</option>
                    <option [ngValue]="NaN">Libre</option>
                </select>
            </div>
        </div>
        <image-cropper output="base64" *ngIf="imageBase64" [imageBase64]="imageBase64" format="jpeg"
            [maintainAspectRatio]="shouldMaintainAspectRatio" [aspectRatio]="aspectRatio" [resizeToWidth]="512"
            (imageLoaded)="onImageLoaded()" (imageCropped)="onCropped($event)"></image-cropper>
        <div class="actions">
            <button (click)="confirmCrop()">Aceptar</button>
            <button (click)="cancel.emit()">Cancelar</button>
        </div>
    </div>
</div>